<template>
  <div class='app-wrapper'>
    <layout-sidebar class='sidebar-container' :style='"display: " + sidebarDisplay + ";" '/>
    <div class='main-container' :style='"margin-left: " + (sidebarDisplay === "block" ? variables.sideBarWidth : 0) + ";"'>
      <layout-navbar @changeSideBarState='changeSideBarState'/>
      <layout-main/>
      <layout-footer/>
    </div>
  </div>
</template>

<script>
import { LayoutSidebar, LayoutNavbar, LayoutMain, LayoutFooter } from './components'
import variables from '@/styles/frame.scss'

export default {
  name: 'Layout',
  components: {
    LayoutSidebar,
    LayoutNavbar,
    LayoutMain,
    LayoutFooter
  },
  data: function () {
    return {
      sidebarDisplay: 'block'
    }
  },

  computed: {
    variables: function () {
      return variables
    }
  },

  methods: {
    changeSideBarState: function () {
      const that = this
      if (that.sidebarDisplay === 'block') {
        that.sidebarDisplay = 'none'
      } else {
        that.sidebarDisplay = 'block'
      }
    }
  }
}
</script>

<style scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
